import { Link } from 'react-router';
import { cn } from '../lib/cn';
import { useBranding } from '../lib/branding';

/** "W" tile + wordmark (S1–S5). `inverted` for the dark staff sidebar. */
export function Logo({ className, inverted, to = '/', suffix }: { className?: string; inverted?: boolean; to?: string; suffix?: string }) {
  const {data}=useBranding();
  return (
    <Link to={to} className={cn('flex shrink-0 items-center gap-2.5 rounded-lg', className)}>
      <span
        aria-hidden
        className={cn('inline-flex size-8 items-center justify-center rounded-md text-[15px] font-bold', inverted ? 'bg-white text-sidebar' : 'bg-strong text-strong-ink')}
      >
        {data?.logoUrl?<img src={data.logoUrl} alt="" className="size-8 rounded-md object-contain"/>:'W'}
      </span>
      <span className={cn('max-w-[11rem] truncate text-[17px] font-semibold', inverted ? 'text-sidebar-ink-strong' : 'text-ink')}>{data?.orgName??'Workdesk'}</span>
      {suffix && <span className={cn('ml-auto pl-3 font-mono text-[11px] tracking-[0.08em] uppercase', inverted ? 'text-sidebar-muted' : 'text-muted')}>{suffix}</span>}
    </Link>
  );
}
